import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.module.scss";
import PageHeader from "../../global/PageHeader/PageHeader";
import DropdownIcon from "../../assets/images/arrow-square-down.svg";
import SortIcon from "../../assets/images/sort-icon.svg";
import Table from "./_components/Table/Table";
import NotFound from "./_components/NotFound/NotFound";
import AddRewardModal from "./_components/Modal/AddReward/AddReward";
import SelectSeller from "./_components/Select/SelectSeller";
import {
  clearRewardSearch,
  deleteRewardReducer,
  searchRewards,
  sortRewards,
} from "../Redux/Reducer/rewardReducer";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";
import DeleteRewardItemModal from "./_components/Modal/Delete/Delete";
import { toast } from "react-toastify";
import { deleteReward } from "../../helpers/service";

const Rewards = () => {
  const dispatch = useDispatch();
  const { rewardSearchResults, rewards } = useSelector(
    (state) => state.rewardReducer
  );
  const { role } = useSelector((state) => state.authReducer);
  const { sellers } = useSelector((state) => state.appReducer);
  const [loading, setLoading] = useState(false);
  const [selectSellerRewards, setSelectSellerRewards] = useState([]);

  const [isAddRewardModalOpen, setIsAddRewardModalOpen] = useState(false);
  const [selectedSellerId, setSelectedSellerId] = useState("");
  const [isDeleteRewardModalOpen, setIsDeleteRewardModalOpen] = useState(false);
  const [deleteRewardId, setDeleteRewardId] = useState("");
  const [editRewardId, setEditRewardId] = useState("");

  useEffect(() => {
    if (selectedSellerId) {
      setSelectSellerRewards(
        rewards.filter((reward) => reward.sellerId === selectedSellerId)
      );
    }
  }, [selectedSellerId]);

  const sortOptions = ["Name (A-Z)", "Name (Z-A)", "Last Modified"];

  const handleSearch = (e) => {
    const query = e.target.value.trim();
    query ? dispatch(searchRewards(query)) : dispatch(clearRewardSearch());
  };

  const handleSort = (sortOption) => {
    dispatch(sortRewards(sortOption));
  };

  const toggleAddRewardModal = () => {
    setIsAddRewardModalOpen(!isAddRewardModalOpen);
  };

  const handleDeleteReward = async () => {
    setLoading(true);
    try {
      await deleteReward(deleteRewardId);
      setLoading(false);
      dispatch(deleteRewardReducer(deleteRewardId));
      setIsDeleteRewardModalOpen(false);
      toast.success("Reward deleted successfully");
    } catch (error) {
      toast.error("Failed to delete reward");
      setLoading(false);
    }
  };

  const renderAdminContent = () => (
    <>
      <h2 className={styles.adminHeaderTitle}>Seller Rewards</h2>
      {selectedSellerId && (
        <SelectSeller
          selectedSellerId={selectedSellerId}
          setSelectedSellerId={setSelectedSellerId}
          sellers={sellers}
        />
      )}
    </>
  );

  const renderTableContent = () => {
    const length =
      role === "admin"
        ? selectSellerRewards.length
        : rewardSearchResults.length;
    return (
      <div className={styles.rewardsTableWrapper}>
        {length === 0 ? (
          <div className={styles.notFoundContainer}>
            <NotFound handleAddReward={toggleAddRewardModal} />
          </div>
        ) : (
          <Table
            rewards={
              role === "admin" ? selectSellerRewards : rewardSearchResults
            }
            setIsAddRewardModalOpen={setIsAddRewardModalOpen}
            setIsDeleteRewardModalOpen={setIsDeleteRewardModalOpen}
            setDeleteRewardId={setDeleteRewardId}
            setEditRewardId={setEditRewardId}
          />
        )}
      </div>
    );
  };

  return (
    <div className={styles.rewardsWrapper}>
      {loading && <CuteMascotSpinner />}
      <DeleteRewardItemModal
        openModal={isDeleteRewardModalOpen}
        toggle={() => {
          setIsDeleteRewardModalOpen(!isDeleteRewardModalOpen);
        }}
        deleteReward={handleDeleteReward}
      />
      <AddRewardModal
        openModal={isAddRewardModalOpen}
        toggle={() => {
          setDeleteRewardId("");
          setEditRewardId("");
          toggleAddRewardModal();
        }}
        setLoading={setLoading}
        editRewardId={editRewardId}
        selectedSellerId={selectedSellerId}
      />
      <div className={styles.rewardsInner}>
        <div className={styles.pageHeaderWrapper}>
          {role === "admin" ? (
            <div className={styles.adminHeader}>{renderAdminContent()}</div>
          ) : (
            <PageHeader
              title="Rewards"
              sortOptions={sortOptions}
              onSearch={handleSearch}
              onSort={handleSort}
              onAdd={toggleAddRewardModal}
              addButtonLabel="Add Reward"
              SortIcon={SortIcon}
              DropdownIcon={DropdownIcon}
            />
          )}
        </div>
        {role === "admin" ? (
          selectedSellerId ? (
            <div className={styles.adminRewardsTableWrapper}>
              {renderTableContent()}
            </div>
          ) : (
            <div className={styles.selectSellerWrapper}>
              <SelectSeller
                selectedSellerId={selectedSellerId}
                setSelectedSellerId={setSelectedSellerId}
                sellers={sellers}
              />
            </div>
          )
        ) : (
          renderTableContent()
        )}
      </div>
    </div>
  );
};

export default Rewards;
